/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Shortcuts_Keys_WinInputs */

const en_pc_tut_shortcuts_keys_win = /** @type {(inputs: Pc_Tut_Shortcuts_Keys_WinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows and Linux`)
};

const zh_pc_tut_shortcuts_keys_win = /** @type {(inputs: Pc_Tut_Shortcuts_Keys_WinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows 与 Linux`)
};

/**
* | output |
* | --- |
* | "Windows and Linux" |
*
* @param {Pc_Tut_Shortcuts_Keys_WinInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_shortcuts_keys_win = /** @type {((inputs?: Pc_Tut_Shortcuts_Keys_WinInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Shortcuts_Keys_WinInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_shortcuts_keys_win(inputs)
	return zh_pc_tut_shortcuts_keys_win(inputs)
});
export { pc_tut_shortcuts_keys_win as "pc.tut.shortcuts.keys_win" }